import React from 'react';
import { Router, Route, Switch, withRouter } from 'react-router';
import withRole from 'components/Security/withRole';
import DataGridStateContextProvider from 'components/DataGrid/DataGridStateContext';
import {
  ROLE_CREATE_DISH_CATEGORY,
  ROLE_EDIT_DISH_CATEGORY,
  ROLE_SHOW_DISH_CATEGORY,
} from 'helpers/roles';

import List from './List';
import Form from './Form';

const DishCategories = props => {
  const { history, match } = props;
  const ListSecured = withRole(ROLE_SHOW_DISH_CATEGORY, List);
  const CreateForm = withRole(ROLE_CREATE_DISH_CATEGORY, Form);
  const EditForm = withRole(ROLE_EDIT_DISH_CATEGORY, Form);

  return (
    <DataGridStateContextProvider>
      <Router history={history}>
        <Switch>
          <Route
            exact={true}
            path={`${match.url}/`}
            render={parentProps => <ListSecured {...props} {...parentProps} />}
          />
          <Route
            path={`${match.url}/add`}
            render={() => <CreateForm {...props} />}
          />
          <Route
            path={`${match.url}/edit/:id`}
            render={parentProps => <EditForm {...props} {...parentProps} />}
          />
        </Switch>
      </Router>
    </DataGridStateContextProvider>
  );
};

export default withRouter(DishCategories);
